var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 16.5C3.8375 16.5 3.48438 16.3531 3.19063 16.0594C2.89687 15.7656 2.75 15.4125 2.75 15V4.5C2.75 4.0875 2.89687 3.73438 3.19063 3.44063C3.48438 3.14688 3.8375 3 4.25 3H5V1.5H6.5V3H12.5V1.5H14V3H14.75C15.1625 3 15.5156 3.14688 15.8094 3.44063C16.1031 3.73438 16.25 4.0875 16.25 4.5V15C16.25 15.4125 16.1031 15.7656 15.8094 16.0594C15.5156 16.3531 15.1625 16.5 14.75 16.5H4.25ZM4.25 15H14.75V7.5H4.25V15ZM4.25 6H14.75V4.5H4.25V6Z",
    fill: "#6710A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.c99dc8139371d600445c118f56640933.svg";
export { ForwardRef as ReactComponent };